export const uiTrelloBoard = {
    name: 'UI Trello Board',
    description: '',
    displayField: 'name',
    fields: {
        name: {
            name: 'Name',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        layout: {
            name: 'Layout',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Desktop', 'Mobile'] }]
        },
        lists: {
            name: 'Lists',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiTrelloList'] }],
                linkType: 'Entry'
            }
        },
        background: {
            name: 'Background',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiTrelloBoard.js.map